<div class="page-container">
  <span class="dialog-title">Download NB Pack</span>

  <form [formGroup]="downloadForm" id="download-nb-pack-form">
    <div class="form-fields">
      <input
        pInputText
        class="form-field"
        placeholder="Policy code"
        formControlName="policyCode"
      />
      <label class="form-field checkbox-label">
        <p-checkbox formControlName="fromArchived" [binary]="true" />
        <span>From archived</span>
      </label>
    </div>
  </form>

  @if (errorMessage) {
    <span class="error-message">{{ errorMessage }}</span>
  }

  <div class="dialog-actions">
    @if (isDownloadInProgress) {
      <p-progressspinner ariaLabel="loading" styleClass="download-spinner" />
    }
    <p-button
      label="Close"
      severity="secondary"
      [disabled]="isDownloadInProgress"
      (onClick)="close()"
    />
    <p-button
      label="Download"
      [disabled]="downloadForm.invalid || isDownloadInProgress"
      (onClick)="download()"
    />
  </div>
</div>
